import React from 'react'

import styles from './FormInputBlock.module.scss'

const FormInputBlock = ({ children }) => <div className={styles.formInputBlock}>{children}</div>

export default FormInputBlock
